var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyright(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 1.66663C5.39996 1.66663 1.66663 5.39996 1.66663 9.99996C1.66663 14.6 5.39996 18.3333 9.99996 18.3333C14.6 18.3333 18.3333 14.6 18.3333 9.99996C18.3333 5.39996 14.6 1.66663 9.99996 1.66663ZM10.2 12.7083C10.85 12.7083 11.4916 12.4666 11.9833 12.0333C12.2416 11.8083 12.6416 11.8333 12.8666 12.0916C13.0916 12.35 13.0666 12.75 12.8083 12.975C12.0833 13.6166 11.1583 13.9666 10.2 13.9666C8.01663 13.9666 6.24163 12.1916 6.24163 10.0083C6.24163 7.82496 8.01663 6.04996 10.2 6.04996C11.1583 6.04996 12.0916 6.39996 12.8083 7.04163C13.0666 7.26663 13.0916 7.66663 12.8666 7.92496C12.6333 8.18329 12.2416 8.20829 11.9833 7.98329C11.4916 7.54996 10.8583 7.30829 10.2 7.30829C8.70829 7.30829 7.49163 8.52496 7.49163 10.0166C7.49163 11.5083 8.70829 12.7083 10.2 12.7083Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyright);
export default __webpack_public_path__ + "static/media/copyright.32fb24d3bc4a6c54e5f5af33bc265ea3.svg";
export { ForwardRef as ReactComponent };